import { render, staticRenderFns } from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=template&id=69265586&scoped=true&lang=pug"
import script from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=style&index=0&id=69265586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69265586",
  null
  
)

export default component.exports